import {
  getWebInstrumentations,
  initializeFaro,
  LogLevel,
} from '@grafana/faro-web-sdk';
import * as Sentry from '@sentry/browser';
import config from 'config';

export const initializeGrafanaFaro = () => {
  if (!config.faro.url) return;

  try {
    initializeFaro({
      url: config.faro.url,
      app: {
        name: 'host',
        namespace: 'host',
        environment: config.environment,
      },
      instrumentations: [
        ...getWebInstrumentations({
          enablePerformanceInstrumentation: false,
        }),
      ],
      trackResources: false,
      logLevel: LogLevel.ERROR,
    });
  } catch (e) {
    Sentry.captureException(e);
  }
};
